import { PromoBannerType } from "@faire/deprecated-retailer-visitor-shared/components/Notifications/PromoBanner/bannerOrder";
import { usePaymentTerm } from "@faire/deprecated-retailer-visitor-shared/hooks/retailer/usePaymentTerm";
import { specialHolidayNet90Active } from "@faire/deprecated-retailer-visitor-shared/settings/getSettingSpecialHolidayNet90";
import { useCreditSummary } from "@faire/deprecated-retailer-visitor-shared/stores/domain/useCreditSummary";
import { usePromoBanners } from "@faire/deprecated-retailer-visitor-shared/stores/ui/usePromoBanners";
import { isNotUndefined } from "@faire/web/common/typescriptUtils";

export const useFOIBannerOrder = () => {
  const { isRetailerOnNetTerms } = usePaymentTerm();
  const { isLoading } = useCreditSummary();
  const { showOpenWithFaireEligibleToApplyBanner } = usePromoBanners();

  const showPaymentTermsBanner =
    isRetailerOnNetTerms &&
    !specialHolidayNet90Active() &&
    !showOpenWithFaireEligibleToApplyBanner &&
    !isLoading;

  const banners = [
    PromoBannerType.FIRST_ORDER_INCENTIVE,
    showOpenWithFaireEligibleToApplyBanner
      ? PromoBannerType.OPEN_WITH_FAIRE
      : undefined,
    showPaymentTermsBanner ? PromoBannerType.PAYMENT_TERMS : undefined,
  ].filter(isNotUndefined);

  return banners;
};
